export default __webpack_public_path__ + "static/media/authBackground.e48637e2.jpg";